var _path, _g, _path2, _g2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUplodImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1433_5754",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 9,
    width: 30,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.92395H29.2136V29.9999H0V9.92395Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1433_5754)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7359 29.9999H6.47824C2.90681 29.9999 0 27.0946 0 23.5217V16.4007C0 12.8293 2.90681 9.92395 6.47824 9.92395H7.84107C8.44581 9.92395 8.93661 10.4147 8.93661 11.0195C8.93661 11.6242 8.44581 12.115 7.84107 12.115H6.47824C4.11335 12.115 2.19106 14.0373 2.19106 16.4007V23.5217C2.19106 25.8866 4.11335 27.8088 6.47824 27.8088H22.7359C25.0993 27.8088 27.0231 25.8866 27.0231 23.5217V16.3876C27.0231 14.0315 25.1066 12.115 22.752 12.115H21.3745C20.7698 12.115 20.279 11.6242 20.279 11.0195C20.279 10.4147 20.7698 9.92395 21.3745 9.92395H22.752C26.3146 9.92395 29.2141 12.8235 29.2141 16.3876V23.5217C29.2141 27.0946 26.3073 29.9999 22.7359 29.9999Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1433_5754",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 3,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5107 0H15.7018V19.7793H13.5107V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1433_5754)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6063 19.7793C14.0015 19.7793 13.5107 19.2885 13.5107 18.6838V1.09541C13.5107 0.490676 14.0015 -0.00012207 14.6063 -0.00012207C15.211 -0.00012207 15.7018 0.490676 15.7018 1.09541V18.6838C15.7018 19.2885 15.211 19.7793 14.6063 19.7793Z",
    fill: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3486 6.4689C10.0696 6.4689 9.78914 6.36227 9.57587 6.14901C9.14789 5.72248 9.14496 5.0301 9.57295 4.60066L13.8309 0.323707C14.2414 -0.0896731 14.9717 -0.0896731 15.3822 0.323707L19.6416 4.60066C20.0681 5.0301 20.0667 5.72248 19.6387 6.14901C19.2092 6.57553 18.5169 6.57553 18.0903 6.14608L14.6065 2.64915L11.1242 6.14608C10.911 6.36227 10.629 6.4689 10.3486 6.4689Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUplodImg);
export default __webpack_public_path__ + "static/media/uplod-img.056d20638ae202819690b5c756454ed3.svg";
export { ForwardRef as ReactComponent };